import { useCurrentOrgId } from '@/stores/authStore'
import request from './request'
import { zodDeviceTokenResponseValidator, type DeviceTokenResponse } from './types/DeviceToken'
import { useQuery } from '@tanstack/react-query'

/* ---------------------------- Device Tokens ---------------------------- */

const getDeviceTokens = async () => {
  const res = await request<DeviceTokenResponse[]>({
    endpoint: '/user/devices/tokens',
    method: 'GET'
  })
  if (res.success) zodDeviceTokenResponseValidator(res.data)
  return res
}

export const useGetDeviceTokens = () => {
  const currOrgId = useCurrentOrgId()
  return useQuery({
    queryKey: [currOrgId, 'user', 'devices', 'tokens'],
    queryFn: getDeviceTokens
  })
}

export const addDeviceToken = async (
  expoToken: DeviceTokenResponse['token']
) => await request({
  endpoint: '/user/devices/tokens',
  method: 'POST',
  body: { expoToken }
})

export const removeDeviceToken = async (
  id: DeviceTokenResponse['id']
) => await request({
  endpoint: `/user/devices/tokens/${id}`,
  method: 'DELETE',
})
